<template>
    <div class="space-y-0 mt-4">
        <label class="py-0">Sent Log</label>
        <div class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
            <div class="flex-1 border-l border-r border-gray-200 px-2 py-1 w-full">Sent to</div>
            <div class="w-40 border-r border-gray-200 px-2 py-1">Requested at</div>
            <div class="flex-1 border-r border-gray-200 px-2 py-1 w-full">Action</div>
            <div class="w-6 flex-shrink-0 ml-2"></div>
        </div>
        <template v-for="(row,index) in logData">
            <send-request :key="row.id" :send-request="row" v-if="row.type==='sendLog'"
                          @revoke="(i) => $emit('revoke',i)"
                          @resend="(i) => $emit('resend',i)"></send-request>
            <div class="flex border-collapse border-b border-gray-200 text-gray-400 italic justify-center items-center "
                 v-else>
                <div class="border-l border-r flex-1 truncate py-1 px-2 text-center bg-blue-50">
                    {{ row.data }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import SendRequest from "./SendRequest.vue";
import moment from "moment";

export default {
    components: {SendRequest},
    props: {
        sendLog: Array,
        injectedData: {
            type: Array, default: () => []
        }
    },
    computed: {},
    data() {
        let logData = []
        this.injectedData.forEach(inject => {
            inject.type = 'inject'
            logData.push(inject);
        })
        this.sendLog.forEach(sendLog => {
            sendLog.type = 'sendLog'
            sendLog.date = sendLog.requested.at
            logData.push(sendLog);
        })
        logData.sort((a, b) => moment(b.date).unix() - moment(a.date).unix());
        return {
            logData: logData
        }
    },
    methods: {},
    async mounted() {
    }
}
</script>